import { render, staticRenderFns } from "./LabInvestigations.vue?vue&type=template&id=1298393c&scoped=true&"
import script from "./LabInvestigations.vue?vue&type=script&lang=js&"
export * from "./LabInvestigations.vue?vue&type=script&lang=js&"
import style0 from "./LabInvestigations.vue?vue&type=style&index=0&id=1298393c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298393c",
  null
  
)

export default component.exports